/* eslint-disable */
import axios from "axios";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Checkbox,
  Tooltip,
} from "@material-ui/core";
import DeleteIcon from '@material-ui/icons/Delete';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import {
  getSections,
  getEnums,
  updateSurvey,
  saveSurvey, handleDelete,
} from "../../utils/store/actions/survey.action";
import SelectAllButton from "./SelectAllButton";

const sortQuestions = (
  q1: { questionOrder: Number },
  q2: { questionOrder: Number }
) => {
  if (q1.questionOrder && q2.questionOrder) {
    if (q1.questionOrder > q2.questionOrder) return 1;
    if (q1.questionOrder < q2.questionOrder) return -1;
  }

  return 0;
};

const sortSections = (
  s1: { sectionOrder: Number },
  s2: { sectionOrder: Number }
) => {
  if (s1.sectionOrder && s2.sectionOrder) {
    if (s1.sectionOrder > s2.sectionOrder) return 1;
    if (s1.sectionOrder < s2.sectionOrder) return -1;
  }

  return 0;
};

const styles = (theme: Theme) =>
  createStyles({
    dangerZone: {
      backgroundColor: "#e85f5f",
    },
    dangerInfo: {
      backgroundColor: "#ff0000",
      color: "#ffffff",
      fontWeight: "bold",
      marginLeft: "1em",
      padding: "0.2em 1em",
      borderRadius: "15px",
      boxShadow: "0px 0px 30px -8px #ffffff",
    },
    whiteLabel: {
      color: "#ffffff",
    },
  });

class ConfigQuestionnaire extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      checked: [],
    };
  }
  componentDidMount() {
    this.setState({ checked: this.props.Surveys.sections });
  }

  handleChange = (event: any, value?: boolean) => {
    const sections = this.state.checked;
    const id = event.target.id.split("_").slice(1).join("_");
    const params = event.target.id.split("_")[0];

    sections.forEach((sec: any, i: any) => {
      if (sec.questions.length) {
        if (
          sec.questions.find((q: any) => {
            return q.id === id;
          })
        ) {
          sec.questions.find((q: any) => {
            return q.id === id;
          })[params] = !sec.questions.find((q: any) => {
            return q.id === id;
          })[params];
          this.setState({ ...this.state, checked: sections });
        }
      } else {
        sec.subSection.forEach((sub: any) => {
          if (sub.questions !== []) {
            if (
              sub.questions.find((q: any) => {
                return q.id === id;
              })
            ) {
              if (typeof value !== undefined) {
                sub.questions.find((q: any) => {
                  return q.id === id;
                })[params] = value;
              } else {
                sub.questions.find((q: any) => {
                  return q.id === id;
                })[params] = !sub.questions.find((q: any) => {
                  return q.id === id;
                })[params];
              }

              this.setState({ ...this.state, checked: sections });
            }
          }
        });
      }
    });
  };

  selectAll = (id: any, visibleType: string): any => {
    // find all fields in section
    let array: any = [];
    this.state.checked.forEach((structure: any) => {
      const tempArray = structure.subSection.filter(
        (section: any) => section.id === id
      );
      if (tempArray.length > 0) {
        array = tempArray;
      }
    });

    if (array[0].questions) {
      const allFieldsVisible = array[0].questions.every(
        (question: any) => question[visibleType]
      );

      array[0].questions.forEach((question: any) => {
        const event = {
          target: {
            id: `${visibleType}_${question.id}`,
          },
        };
        this.handleChange(event, !allFieldsVisible);
      });
    }
  };

  componentWillUnmount() {
    this.props.updateSurvey(this.state.checked);
  }

  isSubSectionVisible(sec: any, sub: any) {
    return !(sec.name === "document" && sub.name === "subscription");
  }

  render() {
    const { t, classes } = this.props;

    return (
      <div>
        {this.state.checked?.map((sec: any) => (
          <Accordion
            className={sec.name === "identification" ? classes.dangerZone : ""}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-label="Expand"
              aria-controls="additional-actions1-content"
              id="additional-actions1-header"
            >
              {t(`distributor:${sec.label}`)}
              {sec.name === "identification" && (
                <div className={classes.dangerInfo}>
                  DEFAULT CONFIGURATION
                </div>
              )}
            </AccordionSummary>
            <AccordionDetails>
              <TableContainer component={Paper}>
                <Table stickyHeader aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell></TableCell>
                      <TableCell align="right">visible Operator</TableCell>
                      <TableCell align="right">visible Investor</TableCell>
                      <TableCell align="right">visible Distributor</TableCell>
                      <TableCell align="right">mandatory</TableCell>
                      <TableCell align="right">
                        <Tooltip title="Visible même si le owner est externe">
                          <span>visible owner external</span>
                        </Tooltip>
                      </TableCell>
                      <TableCell align="right">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {sec.questions.length
                      ? sec?.questions.sort(sortQuestions).map((q: any) => (
                        <TableRow>
                          <TableCell component="th" scope="row">
                            <>
                              ({q.questionOrder}) [{q.key}] {t(q.label)}
                              {q.personType && (
                                <small>({t(q.personType)})</small>
                              )}
                            </>
                          </TableCell>
                          <TableCell size="small" align="right">
                            <Checkbox
                              onChange={this.handleChange}
                              id={`visibleOperator_${q.id}`}
                              checked={q.visibleOperator}
                              inputProps={{
                                "aria-label": "primary checkbox",
                              }}
                            />
                          </TableCell>
                          <TableCell size="small" align="right">
                            <Checkbox
                              onChange={this.handleChange}
                              id={`visibleInvestor_${q.id}`}
                              checked={q.visibleInvestor}
                              inputProps={{
                                "aria-label": "primary checkbox",
                              }}
                            />
                          </TableCell>
                          <TableCell size="small" align="right">
                            <Checkbox
                              onChange={this.handleChange}
                              id={`visibleDistributor_${q.id}`}
                              checked={q.visibleDistributor}
                              inputProps={{
                                "aria-label": "primary checkbox",
                              }}
                            />
                          </TableCell>
                          <TableCell size="small" align="right">
                            <Checkbox
                              onChange={this.handleChange}
                              id={`mandatory_${q.id}`}
                              checked={q.mandatory}
                              inputProps={{
                                "aria-label": "primary checkbox",
                              }}
                            />
                          </TableCell>
                          <TableCell size="small" align="right">
                            <Checkbox
                              onChange={this.handleChange}
                              id={`visibleOwnerExternal${q.id}`}
                              checked={q.visibleOwnerExternal}
                              inputProps={{
                                "aria-label": "primary checkbox",
                              }}
                            />
                          </TableCell>
                          <TableCell align="right">
                            {q.hasAnswers ? ("") :
                              (<Button color="primary" onClick={() => { handleDelete(q.id, this.props.party) }}>
                                <DeleteIcon className="test" />
                              </Button>)}
                          </TableCell>
                        </TableRow>
                      ))
                      : sec.subSection.filter((sub: any) => this.isSubSectionVisible(sec, sub)).sort(sortSections).map((sub: any) => (
                        <>
                          <TableRow style={{ backgroundColor: "lightgrey" }}>
                            <TableCell component="th" scope="row">
                              [{sub.label}] {t(`distributor:${sub.label}`)}
                            </TableCell>

                            {[
                              "visibleOperator",
                              "visibleInvestor",
                              "visibleDistributor",
                              "mandatory",
                              "visibleOwnerExternal",
                            ].map((visible: string) => {
                              return (
                                <TableCell size="small" align="right">
                                  <SelectAllButton
                                    onClick={() => {
                                      this.selectAll(sub.id, visible);
                                    }}
                                  />
                                </TableCell>
                              );
                            })}
                            <TableCell align="right"></TableCell>
                          </TableRow>
                          {sub?.questions
                            .filter(q => (!this.props.configuredOnly) || q.visibleOperator || q.visibleInvestor || q.visibleDistributor)
                            .sort(sortQuestions)
                            .map((q: any) => (
                              <TableRow id={q.id}
                                style={{
                                  backgroundColor: `${q.type === "TITLE" && "#C7A3D1"
                                    }`,
                                }}
                              >
                                <TableCell component="th" scope="row">
                                  {q.type === "TITLE" ? (
                                    <Tooltip title={t("TITLE_OF_QUESTION")}>
                                      <strong>[{q.key}] {t(q.label)} **</strong>
                                    </Tooltip>
                                  ) : (
                                    <>
                                      ({q.questionOrder}) [{q.key}] {t(q.label)}
                                      {q.personType && (
                                        <small>({t(q.personType)})</small>
                                      )}
                                    </>
                                  )}
                                </TableCell>
                                <TableCell size="small" align="right">
                                  <Checkbox
                                    onChange={this.handleChange}
                                    id={`visibleOperator_${q.id}`}
                                    checked={q.visibleOperator}
                                    inputProps={{
                                      "aria-label": "primary checkbox",
                                    }}
                                  />
                                </TableCell>
                                <TableCell size="small" align="right">
                                  <Checkbox
                                    onChange={this.handleChange}
                                    id={`visibleInvestor_${q.id}`}
                                    checked={q.visibleInvestor}
                                    inputProps={{
                                      "aria-label": "primary checkbox",
                                    }}
                                  />
                                </TableCell>
                                <TableCell size="small" align="right">
                                  <Checkbox
                                    onChange={this.handleChange}
                                    id={`visibleDistributor_${q.id}`}
                                    checked={q.visibleDistributor}
                                    inputProps={{
                                      "aria-label": "primary checkbox",
                                    }}
                                  />
                                </TableCell>
                                <TableCell size="small" align="right">
                                  <Checkbox
                                    onChange={this.handleChange}
                                    id={`mandatory_${q.id}`}
                                    checked={q.mandatory}
                                    inputProps={{
                                      "aria-label": "primary checkbox",
                                    }}
                                  />
                                </TableCell>
                                <TableCell size="small" align="right">
                                  <Checkbox
                                    onChange={this.handleChange}
                                    id={`visibleOwnerExternal_${q.id}`}
                                    checked={q.visibleOwnerExternal}
                                    inputProps={{
                                      "aria-label": "primary checkbox",
                                    }}
                                  />
                                </TableCell>
                                <TableCell align="right">
                                  {q.hasAnswers ? ("") :
                                    (<Button color="primary" onClick={() => { handleDelete(q.id, this.props.party) }}>
                                      <DeleteIcon className="test" />
                                    </Button>)}
                                </TableCell>
                              </TableRow>
                            ))}
                        </>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getSections,
  getEnums,
  updateSurvey,
  saveSurvey,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(ConfigQuestionnaire)));
